export const polygonReducer = (state = null, action) => {
    switch (action.type) {
        case 'polygon':
            return action.payload
        default:
            return state
    }
}
export default polygonReducer;